export enum BankFeedSourcesRouteName {
    Index = 'system.bank-feed-sources.index',
    Create = 'system.bank-feed-sources.create',
    Edit = 'system.bank-feed-sources.edit',
}

export default {
    path: 'bank-feed-sources',
    name: BankFeedSourcesRouteName.Index,
    component: () => import('@/views/system/bank-feed-source/Index.vue'),
    meta: {
        auth: true,
        label: 'Bank Feed Sources',
        icon: 'fal fa-university fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-bank-feed-source',
    },
    children: [
        {
            path: 'create',
            name: BankFeedSourcesRouteName.Create,
            component: () => import('@/views/system/bank-feed-source/Index.vue'),
            meta: {
                auth: true,
                label: 'Create Bank Feed Source',
                icon: 'fal fa-envelope fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-bank-feed-source',
            },
        },
        {
            path: ':bankFeedSourceId/edit',
            name: BankFeedSourcesRouteName.Edit,
            component: () => import('@/views/system/bank-feed-source/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit Bank Feed Source',
                icon: 'fal fa-envelope fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-bank-feed-source',
            },
        },
    ],
}
